(() => {
  const storageKey = 'shophearts:return-label:attempt:v1';
  const types = { exchange: 'Exchange', 'store-credit': 'Return for Store Credit' };
  const clearAttempt = () => { try { sessionStorage.removeItem(storageKey); } catch (_) {} };
  const readAttempt = () => {
    try {
      const attempt = JSON.parse(sessionStorage.getItem(storageKey));
      if (!attempt) return null;
      if (!Number.isFinite(attempt.at) || Date.now() - attempt.at < 0 || Date.now() - attempt.at > 30 * 60 * 1000 || !Object.hasOwn(types, attempt.type) || typeof attempt.path !== 'string' || !attempt.path.startsWith('/')) {
        clearAttempt();
        return null;
      }
      return attempt.path === window.location.pathname ? attempt : null;
    } catch (_) { return null; }
  };
  // Restore the alternate template if a platform redirect drops only its view.
  // Preserve Shopify's response parameters; never invent a success parameter.
  const recoverView = () => {
    const attempt = readAttempt();
    const url = new URL(window.location.href);
    if (!attempt) return false;
    if (url.searchParams.get('view') === 'return-label') {
      if (!Object.hasOwn(types, url.searchParams.get('request_type'))) {
        url.searchParams.set('request_type', attempt.type);
        try { window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash); } catch (_) {}
      }
      return false;
    }
    url.searchParams.set('view', 'return-label');
    url.searchParams.set('request_type', attempt.type);
    window.location.replace(url.pathname + url.search + url.hash);
    return true;
  };
  const initialize = root => {
    if (root.shLabelRefresh) { root.shLabelRefresh(); return; }
    const result = root.querySelector('[data-sh-label-result]');
    const form = root.querySelector('form');
    const summary = root.querySelector('[data-sh-label-errors]');
    const attempt = readAttempt();
    if (result) { clearAttempt(); result.focus(); }
    if (!form || !summary) return;
    const fields = [...form.querySelectorAll('[data-sh-label-field]')];
    const requestType = form.elements['contact[Request type]'];
    const uncertain = root.querySelector('[data-sh-label-uncertain]');
    const submit = form.querySelector('button[type="submit"]');
    const selectedType = new URLSearchParams(window.location.search).get('request_type');
    const selected = Object.hasOwn(types, selectedType) ? selectedType : attempt?.type;
    if (selected && !requestType.value) requestType.value = types[selected];
    const updatePageContext = () => {
      const url = new URL(window.location.href);
      const key = Object.keys(types).find(type => types[type] === requestType.value);
      url.searchParams.set('view', 'return-label');
      if (key) url.searchParams.set('request_type', key);
      else url.searchParams.delete('request_type');
      try { window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash); } catch (_) {}
    };
    requestType.addEventListener('change', updatePageContext);
    updatePageContext();
    root.shLabelRefresh = () => {
      if (result || !readAttempt()) return;
      uncertain.hidden = false;
      submit.disabled = true;
      uncertain.focus();
    };
    root.querySelector('[data-sh-label-new]').addEventListener('click', () => {
      clearAttempt();
      uncertain.hidden = true;
      submit.disabled = false;
      form.elements['contact[Order number]'].focus();
    });
    root.shLabelRefresh();
    const messageFor = field => !field.value.trim() || !field.validity.valid ? field.dataset.error : '';
    const mark = field => {
      const message = messageFor(field);
      const error = root.querySelector('[id="' + field.id + '-Error"]');
      field.setAttribute('aria-invalid', message ? 'true' : 'false');
      if (error) { error.textContent = message; error.hidden = !message; }
      return message;
    };
    const updateSummary = () => {
      const list = summary.querySelector('ul');
      list.replaceChildren();
      fields.forEach(field => {
        if (field.getAttribute('aria-invalid') !== 'true') return;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + field.id;
        link.textContent = messageFor(field);
        link.addEventListener('click', event => { event.preventDefault(); field.focus(); });
        item.append(link);
        list.append(item);
      });
      summary.hidden = list.childElementCount === 0;
    };
    fields.forEach(field => {
      const changed = () => {
        if (field.getAttribute('aria-invalid') !== 'true') return;
        mark(field);
        updateSummary();
      };
      field.addEventListener('input', changed);
      field.addEventListener('change', changed);
    });
    form.addEventListener('submit', event => {
      if (!uncertain.hidden) { event.preventDefault(); uncertain.focus(); return; }
      updatePageContext();
      const valid = fields.map(mark).every(message => !message);
      updateSummary();
      if (!valid) { event.preventDefault(); summary.focus(); return; }
      const type = Object.keys(types).find(key => types[key] === requestType.value);
      // Only a short-lived attempt marker; no email, order number or message is stored.
      try { sessionStorage.setItem(storageKey, JSON.stringify({ at: Date.now(), path: window.location.pathname, type })); } catch (_) {}
      // Keep the native POST and CAPTCHA flow. An attempt is never treated as success.
    });
    form.noValidate = true;
  };
  const scan = () => {
    if (recoverView()) return;
    document.querySelectorAll('[data-sh-return-label]').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  window.addEventListener('pageshow', scan);
  document.addEventListener('shopify:section:load', scan);
})();
